import { useEffect } from 'react';

type KeyHandler = () => void;
type KeyBinding = [string, KeyHandler];

/**
 * A hook that sets up global keyboard event listeners for specified key bindings
 * @param keyBindings Array of tuples containing [key: string, handler: () => void]
 * @param enabled Optional boolean to enable/disable all key bindings
 */
export const useKeys = (keyBindings: KeyBinding[], enabled: boolean = true) => {
  useEffect(() => {
    if (!enabled) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      const binding = keyBindings.find(([key]) => key === event.key);
      if (binding) {
        binding[1]();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [keyBindings, enabled]);
};
